import React, { useMemo } from 'react'
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player'

import * as styles from './Player.module.scss'
import { SvgPause, SvgPlay, SvgMute, SvgVolume } from '../ui/svg-icons'

const flex = <div className={styles.flex} />
const dot = <span className={styles.spacer}>•</span>
const slash = <span className={styles.spacer}>/</span>

function Player({ audio, date, ...rest }) {
  const dateElem = useMemo(() => {
    return <span className={styles.date}>{date}</span>
  }, [])

  return (
    <AudioPlayer
      layout="stacked-reverse"
      src={audio}
      showJumpControls={false}
      customProgressBarSection={[RHAP_UI.PROGRESS_BAR]}
      customAdditionalControls={[]}
      customControlsSection={[
        RHAP_UI.MAIN_CONTROLS,
        dateElem,
        dot,
        RHAP_UI.CURRENT_TIME,
        slash,
        RHAP_UI.DURATION,
        flex,
        RHAP_UI.VOLUME,
      ]}
      showDownloadProgress={false}
      volume={0.5}
      customIcons={{
        pause: <SvgPause className={styles.svg} />,
        play: <SvgPlay className={styles.svg} />,
        volume: <SvgVolume width={15} height={15} className={styles.svg} />,
        volumeMute: <SvgMute width={15} height={15} className={styles.svg} />,
      }}
      {...rest}
    />
  )
}

export default Player
